<template>
<div v-if="StaticImage" data-component="PhotoEditor.vue" class="flex flex-col items-center justify-center mb-3">
	<img class="[ image-upload-preview ] rounded" :data-test="`${DataTest}__photo_editor__image`" :src="StaticImage">
</div>
<div v-else data-component="PhotoEditor.vue" class="[ photo-editor ]" :class="{ 'is-avatar-mode': AvatarMode }">
	<!-- <input type="file" @change="OnInputChange" ref="Input"> -->
	<div ref="PhotoEditorPreview" class="[ photo-editor-preview ]" :data-test="`${DataTest}__photo_editor__preview`" :style="{ width: '100%', 'min-height': Size + 'px' }">
		<div ref="CropArea" class="[ photo-editor-crop-area ]" :style="{ width: ((CropAreaSize[0] || (Size * .75)) + 'px'), height: ((CropAreaSize[1] || (Size * .75)) + 'px') }">
			<button v-if="AvatarMode" class="[ photo-editor-rotate-button ] absolute right-0 bottom-0 text-white" @click.prevent.stop="RotatePhoto">
				<OIcon name="rotate" size="2.25"/>
			</button>
		</div>
		<button v-if="!AvatarMode" class="[ photo-editor-rotate-button ] absolute right-0 bottom-0 text-white" @click.prevent.stop="RotatePhoto">
			<OIcon name="rotate" size="2.25"/>
		</button>
		<div class="[ photo-editor-offset ]">
			<img ref="ImageElement" :data-test="`${DataTest}__photo_editor__image`" :src="Input" :style="{ width: ImageSize[0], height: ImageSize[1], transform: 'translate(' + Offset[0] + 'px, ' + Offset[1] + 'px)' }">
		</div>
	</div>
	<div class="flex items-center mt-3">
		<OIcon name="search" size="1" class="mr-3 shrink-0" :data-test="`${DataTest}__photo_editor__zoom`"/>
		<div class="widget-slider">
			<progress :max="2 - 1" :value="Zoom - 1"/>
			<input v-model="Zoom" type="range" min="1" max="2" step="0.01" :data-test="`${DataTest}__photo_editor__range`">
		</div>
	</div>
</div>
</template>

<script lang="ts">
import { addHandler } from '@globals/utilities/HandlerUtils';
import { dataURLToBlob, rotatePhoto } from '@globals/utilities/ImageUtils';

// @vuese
// Komponent odpowiedzialny za skalowanie i kadrowanie zdjęć.
// @group Base Components | Photos
export default {
	name: 'PhotoEditor',
	props: {
		modelValue: { required: false, default: null },
		AvatarMode: { type: Boolean, default: false },
		DataTest: { default: '' },
	},
	data() {
		return {
			Image: null,
			Input: null,
			Dimensions: [0, 0],
			Zoom: 1,
			Size: 300,
			SizeHeight: 300, // TODO: Zamień na tablice
			Offset: [0, 0],
			OffsetBefore: [0, 0],
			Drag: false,
			DragStart: [0, 0],
			DragCurrent: [0, 0],
			DebugInfo: '',
			CropArea: {},
			CropAreaSize: [0, 0],
			Edited: false,
			StaticImage: '',
		};
	},
	computed: {
		ImageSize() {
			const [w, h] = this.Dimensions;
			const size = `${(this.Size * 0.75) * this.Zoom}px`;
			return (w > h) ? ['auto', size] : [size, 'auto'];
		},
	},
	watch: {
		Zoom() {
			this.Refresh();
		},
		modelValue: {
			immediate: true,
			handler(n) {
				if (n.file && !n.edited) {
					this.SetImage(n.file);
				} else {
					this.StaticImage = n.url;
				}
			},
		},
	},
	mounted() {
		this.SetSize();
		this.EventListener(true);
	},
	beforeUnmount() {
		// TODO: beforeUnmount generuje błędy podczas wywoływania removeEventListener?
		this.EventListener(false);
	},
	methods: {
		ConvertToTouch(e) {
			if (!e.touches) { return e; }
			const t = e.touches[0];
			e.clientX = t.clientX;
			e.clientY = t.clientY;
			return t;
		},
		Refresh() {
			this.Edited = this.Drag = true;
			// TODO: Nieeleganckie.
			this.OffsetBefore = this.Offset;
			this.DragStart = [0, 0];
			this.OnDragMove({ clientX: 1, clientY: 1 });
			this.OffsetBefore = this.Offset;
			this.DragStart = [0, 0];
			this.OnDragMove({ clientX: -1, clientY: -1 });
			this.Drag = false;
		},
		OnDragStart(e) {
			e = this.ConvertToTouch(e);
			if (!e.target || e.target.classList.contains('photo-editor-rotate-button')) { return; }
			this.OffsetBefore = this.Offset;
			this.DragStart = [e.clientX, e.clientY];
			this.Drag = true;
		},
		OnDragMove(e) {
			if (!this.Drag) { return; }
			e = this.ConvertToTouch(e);

			const [x, y] = this.DragStart;
			const [newX, newY] = [x - e.clientX, y - e.clientY];
			let [offsetX, offsetY] = [this.OffsetBefore[0] + newX, this.OffsetBefore[1] + newY];

			const crop = this.$refs.CropArea;
			const img = this.$refs.ImageElement;
			if (!crop || !img) { console.warn('[PhotoEditor:OnDragMove] No valid $refs found!'); return; }

			// TODO Czy da się pozbyć imgEdges oraz contraintować pozycję używając getBoundingClientRect()?
			const imgEdges = {
				l: (img.width - crop.offsetWidth) / 2,
				r: -(img.width - crop.offsetWidth) / 2,
				t: (img.height - crop.offsetHeight) / 2,
				b: -(img.height - crop.offsetHeight) / 2,
			};

			const goingUp = (y - e.clientY) > 0;
			const goingLeft = (x - e.clientX) > 0;

			const cropAreaBound = crop.getBoundingClientRect();
			const imgBound = img.getBoundingClientRect();

			let hitBounduary = false;
			if (goingLeft && Math.floor(imgBound.left) >= Math.floor(cropAreaBound.left)) { offsetX = imgEdges.l; hitBounduary = true; } else if (!goingLeft && Math.floor(imgBound.right) <= Math.floor(cropAreaBound.right)) { offsetX = imgEdges.r; hitBounduary = true; }
			if (goingUp && Math.floor(imgBound.top) >= Math.floor(cropAreaBound.top)) { offsetY = imgEdges.t; hitBounduary = true; } else if (!goingUp && Math.floor(imgBound.bottom) <= Math.floor(cropAreaBound.bottom)) {
				offsetY = imgEdges.b; hitBounduary = true;
			}

			this.Offset = [offsetX, offsetY];
			if (hitBounduary) { this.OnDragStart(e); }

			const scale = this.Dimensions[0] / img.width;
			const cropSize = [this.CropAreaSize[0] || this.Size * 0.75, this.CropAreaSize[1] || this.Size * 0.75];
			const area = {
				l: -offsetX + (img.width - cropSize[0]) / 2,
				r: -1,
				t: -offsetY + (img.height - cropSize[1]) / 2,
				b: -1,
				w: -1,
				h: -1,
			};
			area.r = area.l + cropSize[0];
			area.b = area.t + cropSize[1];
			for (const p in area) { area[p] *= scale; area[p] = Math.round(area[p]); }
			area.w = area.r - area.l;
			area.h = area.b - area.t;
			this.CropArea = area;
		},
		OnDragEnd() {
			this.Drag = false;

			window.setTimeout(() => {
				this.Refresh();
			}, 150); // TODO: nextTick?
		},
		async RotatePhoto() {
			const [x, y] = this.Dimensions;
			this.Zoom = 1;
			this.Dimensions = [y, x];
			this.Offset = this.OffsetBefore = [0, 0];
			this.Edited = true;
			const rotated = await rotatePhoto(this.Input);
			const blob = dataURLToBlob(rotated);
			this.SetImage(blob);
			this.SetSize();
			window.setTimeout(() => {
				this.Refresh();
			}, 150); // TODO: nextTick?
		},
		GetCroppedImage() {
			try {
				const area = this.CropArea;
				let canvas = document.createElement('canvas');
				canvas.width = area.w;
				canvas.height = area.h;
				if (!this.Image) {
					console.warn('[PhotoEditor:GetCroppedImage] No valid this.Image found!');
					return null;
				}
				canvas.getContext('2d').drawImage(this.Image, area.l, area.t, area.w, area.h, 0, 0, area.w, area.h);

				const s = 2048;
				if (area.w > s || area.h > s) {
					let [w, h] = [area.w, area.h];
					if (w > h) {
						if (w > s) { h *= (s / w); w = s; }
					} else if (h > s) { w *= (s / h); h = s; }

					const resized = document.createElement('canvas');
					resized.width = w;
					resized.height = h;
					resized.getContext('2d').drawImage(canvas, 0, 0, w, h);
					canvas = resized;
				}

				return canvas.toDataURL('image/jpeg');
			} catch (err) {
				console.warn('GetCroppedImage', err);
			}
			return null;
		},
		async OnInputChange() {
			const img = await this.GetImage(this.$refs.Input.files[0]);
			this.Input = img.data;
			this.Dimensions = img.dimensions;
		},
		SetCropAreaSize() {
			if (this.AvatarMode) { return; }
			// TODO: Wypróbuj jak byłoby to z nextTick
			window.setTimeout(() => {
				if (!this.$refs.ImageElement) { return; }
				const img = this.$refs.ImageElement.getBoundingClientRect();
				this.CropAreaSize = [Math.floor(img.width), Math.floor(img.height)];
			}, 150);
		},
		async SetImage(f) {
			const img = await this.GetImage(f);
			this.Input = img.data;
			this.Dimensions = img.dimensions;
			this.SetCropAreaSize();
		},
		GetImage(f: File) {
			return new Promise((resolve) => {
				const fileReader = new FileReader();
				const img = new Image();
				addHandler(img, 'load', () => {
					const w = img.width; const
						h = img.height;
					const canvas = document.createElement('canvas');
					canvas.width = w;
					canvas.height = h;
					canvas.getContext('2d').drawImage(img, 0, 0, w, h);
					const data = canvas.toDataURL('image/jpeg');
					this.Image = img;
					resolve({ data, dimensions: [w, h] });
				});

				addHandler(fileReader, 'load', (e) => {
					img.src = ((e.target as FileReader).result) as string;
				});

				fileReader.readAsDataURL(f);
			});
		},
		EventListener(add) {
			const method = `${add ? 'add' : 'remove'}EventListener`;
			const ev = (element, events, handler) => {
				if (!element) { return; }
				events.forEach((e) => { element[method](e, handler); });
			};
			ev(this.$refs.PhotoEditorPreview, ['mousedown', 'touchstart'], this.OnDragStart);
			ev(document.body, ['mousemove', 'touchmove'], this.OnDragMove);
			ev(document.body, ['mouseup', 'touchend'], this.OnDragEnd);
			ev(window, ['resize'], this.SetSize);
		},
		SetSize() {
			const el = this.$refs.PhotoEditorPreview;
			this.Size = el ? el.offsetWidth : 300;
			this.SizeHeight = el ? el.offsetHeight : 300;
			this.SetCropAreaSize();
		},
	},
};
</script>

<style lang="scss">
.photo-editor-preview {
	position: relative;
	overflow: hidden;
	margin: auto;
	background: rgba(240, 240, 240, 1);
	border-radius: 4px;
	font-size: 0;
	user-select: none;
}

.photo-editor-crop-area {
	position: absolute;
	z-index: 2;
	top: 50%;
	left: 50%;
	box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.66);
	transform: translate(-50%, -50%);
}

.is-avatar-mode .photo-editor-crop-area {
	border-radius: 100%;
}

.photo-editor-offset {
	position: absolute;
	z-index: 1;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);

	img {
		max-width: initial;
	}
}

.is-photo-only.is-fullscreen {
	.photo-editor {
		display: flex;
		flex-direction: column-reverse;
		margin: -20px;
		margin-bottom: 0;
	}

	.photo-editor-preview {
		min-height: calc(100vh - 218px) !important;
		border-radius: 0;
	}

	.photo-editor > .flex.items-center {
		padding: 0 16px 8px;
	}
}

.photo-editor-rotate-button {
	z-index: 4;
	padding: 0.5rem;
	filter: drop-shadow(0 0 2px black);
}

.widget-slider {
	position: relative;
	height: 52px;
	flex: 1 1 1050px;
}

.widget-slider input[type=range] {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 20px;
	padding: 0;
	border: none;
	margin: 0;
	-webkit-appearance: none;
	background: transparent;
	outline: none;
	-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.widget-slider input[type=range]::-webkit-slider-runnable-track {
	width: 100%;
	height: 2px;
	background: var(--neutral-100);
	cursor: pointer;
	pointer-events: none;
	transform: translateY(-50%);
}

.widget-slider input[type="range"]::-webkit-slider-thumb {
	position: relative;
	z-index: 4;
	width: 16px;
	height: 16px;
	border: none;
	margin-top: 2px;
	-webkit-appearance: none;
	background: var(--accent);
	border-radius: 100%;
	outline: 0;
	pointer-events: all;
	transform: translateY(-50%);
}

.widget-slider input[type="range"]::-webkit-slider-thumb:active {
	transform: translateY(-50%) scale(1.25);
}

.widget-slider input[type=range]::-moz-range-track {
	width: 100%;
	height: 2px;
	background: var(--neutral-100);
	cursor: pointer;
	pointer-events: none;
}

.widget-slider input[type="range"]::-moz-range-thumb {
	position: relative;
	z-index: 4;
	width: 16px;
	height: 16px;
	border: none;
	-webkit-appearance: none;
	background: var(--accent);
	border-radius: 100%;
	outline: 0;
	pointer-events: all;
}

.widget-slider input[type="range"]::-moz-range-thumb:active {
	transform: scale(1.25);
}

.widget-slider input[type=range]::-ms-thumb {
	position: relative;
	z-index: 4;
	width: 16px;
	height: 16px;
	border: none;
	background: var(--accent);
	border-radius: 100%;
	outline: 0;
	pointer-events: all;
	transform: translateY(0%);
}

.widget-slider input[type=range]::-ms-thumb:active {
	transform: translateY(0%) scale(1.25);
}

.widget-slider input[type=range]::-ms-track {
	width: 100%;
	height: 2px;
	border: none;
	background: var(--neutral-100);
	cursor: pointer;
	pointer-events: none;
}

.widget-slider progress {
	position: absolute;
	z-index: 1;
	top: 50%;
	right: 0;
	left: 0;
	width: 100%;
	height: 2px;
	border: none;
	margin-top: -2px;
	-webkit-appearance: none;
	background: transparent;
	pointer-events: none;
}

.widget-slider progress::-webkit-progress-inner-element {
	background: transparent;
}

.widget-slider progress::-webkit-progress-bar {
	background: transparent;
}

.widget-slider progress::-webkit-progress-value {
	background: var(--accent);
}

.widget-slider progress::-ms-fill {
	border: none;
	background: var(--accent);
}

.widget-slider progress::-moz-progress-bar {
	background: var(--accent);
}

</style>
